import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'

/**
 * Indicador de etapas exibido no topo de modais com fluxo em várias etapas.
 * Cada etapa ocupa uma coluna de largura idêntica (`auto-cols-fr`), com o
 * marcador centralizado e a trilha de progresso ligando os marcadores.
 */
export function Steps({ steps, current }) {
  const idx = steps.findIndex((s) => s.key === current)

  return (
    <div className="grid grid-flow-col auto-cols-fr mb-6">
      {steps.map((s, i) => {
        const done = i < idx
        const active = i === idx
        return (
          <div key={s.key} className="flex flex-col items-center gap-2">
            <div className="flex items-center w-full">
              <div
                className={cn(
                  'h-0.5 flex-1 rounded-full transition-colors',
                  i === 0 && 'invisible',
                  done || active ? 'bg-primary' : 'bg-border'
                )}
              />
              <div
                className={cn(
                  'flex items-center justify-center h-7 w-7 mx-1.5 shrink-0 rounded-full border text-xs font-medium transition-colors',
                  done
                    ? 'bg-primary border-primary text-primary-foreground'
                    : active
                    ? 'border-primary text-primary ring-4 ring-primary/15'
                    : 'border-border text-muted-foreground'
                )}
              >
                {done ? <Check className="h-4 w-4" /> : i + 1}
              </div>
              <div
                className={cn(
                  'h-0.5 flex-1 rounded-full transition-colors',
                  i === steps.length - 1 && 'invisible',
                  done ? 'bg-primary' : 'bg-border'
                )}
              />
            </div>
            <span
              className={cn(
                'px-1 text-xs text-center leading-tight transition-colors',
                active ? 'font-medium text-foreground' : 'text-muted-foreground'
              )}
            >
              {s.label}
            </span>
          </div>
        )
      })}
    </div>
  )
}
